/* =========================================================================
   Snuzone – Mobile Drawer Search Panel v10.2 (R2 „Reihe“ + T1 „Chips“, 28.10.2026)
   Datei: assets/snuzone-search-mobile.js
   Scope: <= 989px (Suchmodus im Menü-Drawer #NavDrawer, Panel [data-snzm-search])

   v10.2 – Hardening nach unabhängiger Header-Prüfung (28.10.2026):
   - K  Drawer blieb im Suchmodus hängen: closeDrawer() in header.liquid
        (Tap außerhalb) entfernt nur drawer--is-open, snzm-active blieb stehen,
        das nächste Öffnen über den Burger zeigte die Suche statt des Menüs.
        Der Klassen-Observer beendet den Suchmodus jetzt auch, wenn
        drawer--is-open verschwindet (Feld wird geleert, wie beim Close-Button).
        Ein Eigentümer für den Suchzustand, header.liquid bleibt unverändert.
   - M  Quick-Shop-Hold ohne Fail-Safe: wurde das Modal nie aktiv (Fetch
        scheitert, Slow 3G), lief der Hold unbegrenzt und drehte jeden
        Schließversuch zurück. Jetzt: Hold-Timeout 5 s, bis das Modal aktiv
        wird (danach gilt der Hold wie bisher bis zum Schließen des Modals);
        kein Modal im DOM nach 10 Versuchen beendet den Hold ebenfalls.
        Vorrang für den Kunden: Close-Button, Abbrechen und ESC beenden den
        Hold, bevor sie schließen.
   - Sonst unverändert (v10.1-Verhalten, Rendering, Requests).

   v10.1 – Live-Test-Fix „leere Bühne über MTB“ (Daniel, 27.10.2026):
   - BEFUND: Die MTB-Section setzt drawer--is-open + snzm-active selbst, der
     Fokus bleibt auf <body> (Konsole: activeElement = body). v10 startete das
     Panel ausschließlich über focusin → nichts gerendert, nur das statische
     Trending. Nach dem ersten echten Durchlauf blieb der Inhalt im DOM, deshalb
     „ging es danach“.
   - FIX 1 (unabhängig vom Trigger): MutationObserver auf der Drawer-Klasse.
     Erscheint snzm-active – egal wer die Klasse setzt – wird der Suchmodus
     aktiviert (Idle laden, Tastatur beobachten); verschwindet sie, wird
     aufgeräumt. focusin bleibt als Weg erhalten, beide sind idempotent
     (Flag activeMode).
   - FIX 2 (sauber im Trigger): öffentliche API window.SnzmSearchMobile.open():
     öffnet den Drawer über dieselbe Klassen-Mechanik wie header.liquid, hebt
     inert SYNCHRON auf (das Drawer-Inline-JS flippt inert erst im Observer,
     also asynchron – ein programmatisches focus() davor wird verworfen) und
     fokussiert das Feld noch innerhalb der Nutzergeste, damit iOS die Tastatur
     öffnet. Empfehlung: MTB ruft SnzmSearchMobile.open() statt eigener
     Klassen-/Fokus-Logik.
   - drawer-menu.liquid v1.4.1: Fallback „Neuheiten“ ist ab Render sichtbar
     (nicht mehr hidden) – die Bühne ist nie leer, auch ohne JS-Event.

   v10 – Build nach Design-Freigabe R2 + T1 und Audit-Fixes (Übergabe §5):
   - IDLE: Kicker-Pattern + horizontale Reihe nativer Karten (.grid-product-
     redesign-Klon, identisch zur RV-Section), Spot als letzte Kachel
     (snippets/snuzone-search-spot.liquid v5, Kontext 'tile-mobile', Knoten
     [data-snzm-spot-tile] wird ins jeweils aktive Strip gehängt – einmal
     gerendert, nie doppelt). Fußzeile: Letzte Suchen (Chips) + Trending.
   - TYPING: Vorschläge (getippter Teil 400, Ergänzung 500 invertiert),
     Kollektionen-Chips aus der Predictive-API (nach Titellänge aufsteigend,
     kürzester = Elternkollektion, max. collectionLimit), Produkte als
     2-Spalten-Raster, View-all in der Kopfzeile.
   - #1 Predictive-Request: resources[type]=query,product,collection +
     resources[limit_scope]=each (Limit sonst über alle Typen geteilt).
   - #2 Tastatur: visualViewport-API setzt --snzm-kb auf #NavDrawer, der
     Scrollbereich bekommt im Suchmodus Padding in Tastaturhöhe (CSS im
     Snippet). Nie 100vh, nie innerHeight als Panelhöhe.
   - #3 Progressiv statt Promise.all: wer zuerst antwortet, rendert; der
     zweite hängt an (insertAdjacentHTML 'beforeend'), nie umsortieren.
     Antwort-Gültigkeit über Controller-Identität (ctrl === myCtrl).
   - #4 Recent: fetchProductSlim() mit sessionStorage-Cache snzs_pj:<handle>
     (TTL 5 min, domainweit – derselbe Key wie Desktop v12.1), Fallback
     nach 250 ms sichtbar, Hard-Timeout 3 s pro Request, openSeq-Guard
     verwirft Antworten nach Schließen/Neuöffnen. Der Fallback (Liquid)
     steht sofort – nie eine leere Bühne.
   - #6 Preise quellspezifisch: Predictive = Dezimal (decimalToCents),
     volle Suche + /products/{handle}.js = Cents (centsToCents). Nie nach
     JS-Datentyp. Geld-Fallback nach shop.money_format (inkl. CHF-Apostroph).
   - #7 Labels („In den Warenkorb“, „Suche entfernen“, Wishlist) aus
     Settings/Data-Attributen, nicht mehr hardcodiert.
   - #8 Fehlerzustand: nur wenn BEIDE Requests technisch scheitern
     (null statt leer) → error_text. Sonst „Keine Treffer“.
   - #12 Panel-Lookup auf #NavDrawer gescoped (kein document-weiter Treffer).
   - ESC: wirkt nur noch im Drawer-Suchfeld (vorher global, leerte das
     Drawer-Feld auch bei ESC im Desktop-Panel).
   - Cart-Drawer-Prüfungen entfernt (Shop hat keinen Cart-Drawer).
   - Bewusst unverändert: Quick-Shop-Proxy-Trigger, Drawer-Hold (v6/v7)
     und Kontext-Restore (v4), Capture-Phase-Events, Singleton/reinit,
     Debounce 180 ms ohne Sofort-Invalidierung (Vorgänger-Treffer bleiben
     bis die erste Antwort da ist).
   - Blöcke „ÜBERNOMMEN AUS DESKTOP-LOGIK“ sind nach Spezifikation v12.1
     gebaut – bei Änderung beide Dateien pflegen (Core-Asset später).

   Syntax-Regel (wie Drawer-Snippet): kein ??, kein ?. – ein Parse-Fehler
   killt den gesamten Block.
   Benötigt: drawer-menu.liquid v1.4.0, snuzone-search-spot.liquid v5,
   templates/search.ajax.liquid v3, header.liquid-Schema (Drawer-Suche).
   v3–v8: siehe Git-Historie.
   ========================================================================= */
(function () {
  'use strict';

  if (window.SnzmSearchMobile && typeof window.SnzmSearchMobile.reinit === 'function') {
    window.SnzmSearchMobile.reinit();
    return;
  }

  var MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  var RS_KEY = 'snzs_recent_searches';   /* geteilt mit Desktop */
  var PJ_PREFIX = 'snzs_pj:';             /* Produkt-Cache, geteilt mit Desktop v12.1 */
  var PJ_TTL = 5 * 60 * 1000;
  var FB_DELAY = 250;
  var HARD_TIMEOUT = 3000;
  var DEBOUNCE = 180;
  var HOLD_TIMEOUT = 5000;                /* v10.2 (M): Quick-Shop-Hold ohne aktives Modal */

  var root, drawer, input;
  var elIdle, elTyping, elRecent, elRecentGrid, elFallback, elFallbackGrid, elSpot,
      elProductsGrid, elEmpty, elError, elViewall, elSearches, elSearchesList,
      elSugg, elSuggList, elColls, elCollsList;

  var cfg = {};
  var debounceTimer = null, currentController = null, docBound = false;
  var openSeq = 0;
  var activeMode = false;   /* v10.1: Suchmodus läuft (idempotenter Einstieg) */
  var classObs = null;      /* v10.1: Observer auf snzm-active / drawer--is-open */

  var ICON_X = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_HEART = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7z"/></svg>';
  /* Nativer ATC-Kreis (1:1 aus der RV-Section / Desktop-Klon) */
  var ICON_ATC = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="14" cy="14" r="14" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.9864 7.62938C12.6556 8.31877 12.4258 9.52248 12.4258 11.5262H11.6036C11.6036 9.49021 11.8324 8.13548 12.2447 7.27637C12.4541 6.83997 12.7187 6.51494 13.04 6.30066C13.3639 6.08462 13.7172 6 14.07 6C14.4228 6 14.7761 6.08462 15.1 6.30066C15.4213 6.51494 15.6859 6.83997 15.8953 7.27637C16.3076 8.13548 16.5363 9.49021 16.5363 11.5262H15.7142C15.7142 9.52248 15.4844 8.31877 15.1535 7.62938C14.9914 7.29153 14.8133 7.0948 14.6425 6.98088C14.4744 6.86872 14.2863 6.8187 14.07 6.8187C13.8537 6.8187 13.6656 6.86872 13.4974 6.98088C13.3267 7.0948 13.1486 7.29153 12.9864 7.62938Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00521 9.06998H19.1306L20.1333 19.2858H7.99976L9.00521 9.06998ZM9.75069 9.88868L8.90639 18.4671H19.2269L18.3849 9.88868H9.75069Z" fill="black"/><circle cx="19.7395" cy="19.6952" r="3.2608" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.4123 21.6518V17.7388H20.0645V21.6518H19.4123Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.6965 20.0216H17.7835V19.3694H21.6965V20.0216Z" fill="black"/></svg>';

  /* ---------- Helpers ---------- */
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function hasTag(tags, tag) {
    if (!tag || !tags || !Array.isArray(tags)) return false;
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === tag) return true;
    }
    return false;
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  function resizeImg(url, w) {
    if (!url) return '';
    url = String(url);
    /* Shopify-CDN: width-Parameter bevorzugt, Suffix-Form als Fallback */
    if (/\/cdn\/shop\//.test(url) || /\?/.test(url)) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    return url.replace(/(\.[^.\/]+)$/, '_' + w + 'x$1');
  }

  /* ---------- ÜBERNOMMEN AUS DESKTOP-LOGIK (v12.1-Spezifikation) ---------- */

  /* Predictive-API liefert Dezimal-Strings („12.90“, auch „12,90“ je Locale) */
  function decimalToCents(v) {
    if (v == null || v === '') return 0;
    var s = String(v).replace(/[^\d.,-]/g, '');
    if (!s) return 0;
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    var dec = Math.max(lastDot, lastComma);
    var intPart, fracPart;
    if (dec === -1) { intPart = s; fracPart = ''; }
    else { intPart = s.slice(0, dec); fracPart = s.slice(dec + 1); }
    intPart = intPart.replace(/[.,]/g, '');
    fracPart = (fracPart.replace(/[.,]/g, '') + '00').slice(0, 2);
    var n = parseInt(intPart || '0', 10) * 100 + parseInt(fracPart || '0', 10);
    return isNaN(n) ? 0 : n;
  }

  /* search.ajax.liquid und /products/{handle}.js liefern Cents (Integer) */
  function centsToCents(v) {
    if (v == null || v === '') return 0;
    var n = typeof v === 'number' ? v : parseInt(String(v).replace(/[^\d-]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  /* Geld-Fallback nach shop.money_format (nie fix „€“) */
  function fallbackMoney(cents, fmt) {
    function f(precision, thousands, decimal) {
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = String(fmt || '').match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var value;
    switch (placeholder) {
      case 'amount_no_decimals': value = f(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = f(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = f(0, '.', ','); break;
      case 'amount_with_space_separator': value = f(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = f(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = f(2, '\u2019', '.'); break;
      default: value = f(2, ',', '.');
    }
    if (!match) return value;
    return String(fmt).replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, cfg.moneyFormat); } catch (e) { /* noop */ }
    }
    return fallbackMoney(cents, cfg.moneyFormat);
  }

  /* fetch mit Hard-Timeout (3 s); null = technischer Fehler, {status:404} = Produkt weg */
  function fetchWithTimeout(url, ms) {
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = null;
    if (ctrl) timer = setTimeout(function () { try { ctrl.abort(); } catch (e) { /* noop */ } }, ms);
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'same-origin' })
      .then(function (res) { if (timer) clearTimeout(timer); return res; })
      .catch(function () { if (timer) clearTimeout(timer); return null; });
  }

  function pjGet(handle) {
    try {
      var raw = sessionStorage.getItem(PJ_PREFIX + handle);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.p) return null;
      if (Date.now() - obj.t > PJ_TTL) return null;
      return obj.p;
    } catch (e) { return null; }
  }
  function pjSet(handle, slim) {
    try { sessionStorage.setItem(PJ_PREFIX + handle, JSON.stringify({ t: Date.now(), p: slim })); } catch (e) { /* noop */ }
  }

  /* Schlankes Produktobjekt aus /products/{handle}.js (Cents).
     Ergebnis: { ok, invalid, p } – ok=false bei Netz/Timeout, invalid=true bei 404 */
  function fetchProductSlim(handle) {
    var cached = pjGet(handle);
    if (cached) return Promise.resolve({ ok: true, invalid: false, p: cached });
    return fetchWithTimeout(cfg.localePrefix + '/products/' + encodeURIComponent(handle) + '.js', HARD_TIMEOUT)
      .then(function (res) {
        if (!res) return { ok: false, invalid: false, p: null };
        if (res.status === 404) return { ok: true, invalid: true, p: null };
        if (!res.ok) return { ok: false, invalid: false, p: null };
        return res.json().then(function (p) {
          if (!p || !p.handle) return { ok: true, invalid: true, p: null };
          var slim = {
            handle: p.handle,
            title: p.title || '',
            id: p.id,
            price: centsToCents(p.price),
            compare_at_price: p.compare_at_price == null ? null : centsToCents(p.compare_at_price),
            featured_image: p.featured_image || '',
            tags: Array.isArray(p.tags) ? p.tags : [],
            vid: (p.variants && p.variants[0]) ? p.variants[0].id : null,
            available: p.available !== false
          };
          pjSet(handle, slim);
          return { ok: true, invalid: false, p: slim };
        }).catch(function () { return { ok: false, invalid: false, p: null }; });
      });
  }

  /* Vorschlag: getippter Teil 400, Ergänzung 500 (invertierte Hervorhebung) */
  function suggMarkup(q, term) {
    var t = String(term || '');
    var ql = String(q || '').toLowerCase();
    if (ql && t.toLowerCase().indexOf(ql) === 0) {
      return esc(t.slice(0, ql.length)) + '<b class="snzm-sugg__rest">' + esc(t.slice(ql.length)) + '</b>';
    }
    return esc(t);
  }

  /* Kollektionen: nach Titellänge aufsteigend (kürzester = Elternkollektion), Limit */
  function renderCollections(list) {
    if (!elColls || !elCollsList) return;
    var colls = (list || []).filter(function (c) { return c && c.title && c.url; });
    colls.sort(function (a, b) { return a.title.length - b.title.length; });
    colls = colls.slice(0, cfg.collectionLimit);
    if (!colls.length) { elColls.hidden = true; elCollsList.innerHTML = ''; return; }
    var html = '';
    for (var i = 0; i < colls.length; i++) {
      html += '<a class="snzm-coll__chip' + (i === 0 ? ' is-lead' : '') + '" href="' + esc(colls[i].url) + '">' + esc(colls[i].title) + '</a>';
    }
    elCollsList.innerHTML = html;
    elColls.hidden = false;
  }

  /* Nativer Karten-Klon (.grid-product-redesign) – Markup identisch zur RV-Section
     und zum Desktop-Klon. o = normalisiertes Objekt (Cents). */
  function cardHTML(o) {
    var url = o.url || (cfg.localePrefix + '/products/' + o.handle);
    var hasSale = typeof o.capCents === 'number' && o.capCents > o.priceCents;
    var salePct = hasSale ? Math.round((1 - o.priceCents / o.capCents) * 100) : 0;
    var tags = '';
    if (hasSale && salePct > 0) {
      tags += '<div class="grid-product__tag grid-product__tag--sale">' + esc(cfg.saleLabel) + ' <span data-percent-pack>-' + salePct + '%</span></div>';
    }
    if (o.isNew && cfg.showBadge) {
      tags += '<div class="grid-product__tag grid-product__tag--new">' + esc(cfg.badgeLabel) + '</div>';
    }
    if (cfg.showHeart && o.id) {
      tags += '<button type="button" class="wishlist-button wishlist-button--icon" data-snz-wl'
        + ' data-product-id="' + esc(o.id) + '"'
        + (o.vid ? ' data-variant-id="' + esc(o.vid) + '"' : '')
        + ' data-product-url="' + esc(url) + '"'
        + ' aria-label="' + esc(cfg.labelWishlist) + '">' + ICON_HEART + '</button>';
    }
    var price = hasSale
      ? '<span class="grid-regular-price">' + formatMoney(o.priceCents) + '</span><span class="grid-compare-price">' + formatMoney(o.capCents) + '</span>'
      : '<span>' + formatMoney(o.priceCents) + '</span>';

    return '<div class="custom-grid-product grid-product grid-product-redesign" data-product-handle="' + esc(o.handle) + '">'
      + '<div class="grid-product__content">'
      + '<div class="grid-product__tag-list grid-product__tag-list--top">' + tags + '</div>'
      + '<a href="' + esc(url) + '" class="grid-product__link">'
      + '<div class="grid-product__image-mask">'
      + '<div class="image-wrap" style="position: relative; height: 0; padding-bottom: 100%; overflow: hidden;">'
      + (o.image ? '<img class="grid-product__image" src="' + esc(o.image) + '" alt="' + esc(o.title) + '" loading="lazy" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; opacity: 1; display: block;">' : '')
      + '</div></div></a>'
      + '<div class="grid-product__meta"><div class="grid-product__meta-part">'
      + '<a href="' + esc(url) + '" class="grid-product__title">' + esc(o.title) + '</a>'
      + '<div class="product-price">' + price + '</div>'
      + '</div></div>'
      + '<div class="mobile-add-to-cart pulse" data-mobile-add-to-cart data-handle="' + esc(o.handle) + '" role="button" tabindex="0" aria-label="' + esc(cfg.labelAtc) + '">' + ICON_ATC + '</div>'
      + '</div></div>';
  }
  /* ---------- ENDE ÜBERNOMMEN AUS DESKTOP-LOGIK ---------- */

  /* ---------- Normalisierung der Produkt-Quellen (quellspezifisch) ---------- */

  /* Volle Suche (search.ajax.liquid v3): Cents, cap = Cents|null, isNew Boolean */
  function normFull(p) {
    var priceCents = centsToCents(p.price);
    var cap = (p.cap == null) ? null : centsToCents(p.cap);
    return {
      handle: p.handle || handleFromUrl(p.url),
      url: p.url || '',
      image: p.image || '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (cap !== null && cap > priceCents) ? cap : null,
      available: p.available !== false,
      isNew: p.isNew === true,
      id: p.id || null,
      vid: p.vid || null
    };
  }

  /* Predictive (suggest.json): Dezimal-Strings, Tags-Array */
  function normSuggest(p) {
    var priceCents = decimalToCents(p.price);
    var capCents = decimalToCents(p.compare_at_price_max);
    var img = p.image || (p.featured_image && p.featured_image.url) || '';
    var vid = (p.variants && p.variants[0]) ? p.variants[0].id : null;
    return {
      handle: p.handle || handleFromUrl(p.url),
      url: p.url || '',
      image: img ? resizeImg(img, 540) : '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (capCents > priceCents) ? capCents : null,
      available: p.available !== false,
      isNew: hasTag(p.tags, cfg.newTag),
      id: p.id || null,
      vid: vid
    };
  }

  /* Slim-Objekt aus /products/{handle}.js bzw. Cache: Cents */
  function normSlim(p) {
    var priceCents = centsToCents(p.price);
    var cap = (p.compare_at_price == null) ? null : centsToCents(p.compare_at_price);
    return {
      handle: p.handle,
      url: cfg.localePrefix + '/products/' + p.handle,
      image: p.featured_image ? resizeImg(p.featured_image, 540) : '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (cap !== null && cap > priceCents) ? cap : null,
      available: p.available !== false,
      isNew: hasTag(p.tags, cfg.newTag),
      id: p.id || null,
      vid: p.vid || null
    };
  }

  /* ---------- Recently Viewed (rv_products) ---------- */
  function getRecentItems() {
    try {
      var raw = localStorage.getItem('rv_products');
      if (!raw) return [];
      var items = JSON.parse(raw);
      if (!Array.isArray(items)) return [];
      return items.map(function (i) {
        return (typeof i === 'object' && i !== null && i.handle) ? i : { handle: String(i) };
      });
    } catch (e) { return []; }
  }
  function pruneRecent(invalid) {
    if (!invalid.length) return;
    try {
      var keep = getRecentItems().filter(function (i) { return invalid.indexOf(i.handle) === -1; });
      localStorage.setItem('rv_products', JSON.stringify(keep));
    } catch (e) { /* noop */ }
  }

  function moveSpot(target) {
    if (!elSpot || !target) return;
    if (elSpot.parentNode !== target) target.appendChild(elSpot);
  }
  function showFallback() {
    if (elRecent) elRecent.hidden = true;
    if (elFallback) elFallback.hidden = false;
    moveSpot(elFallbackGrid);
  }
  function showRecent() {
    if (elFallback) elFallback.hidden = true;
    if (elRecent) elRecent.hidden = false;
    moveSpot(elRecentGrid);
  }

  function loadRecent() {
    if (!elRecent || !elRecentGrid) { showFallback(); return; }
    var seq = ++openSeq;
    var items = getRecentItems();
    if (cfg.currentHandle) items = items.filter(function (i) { return i.handle !== cfg.currentHandle; });
    items = items.slice(0, cfg.recentLimit);
    if (!items.length) { showFallback(); return; }

    /* Bühne ist nie leer: Recent bleibt sichtbar, wenn bereits gerendert;
       sonst zeigt die 250-ms-Schwelle den Fallback, bis Recent da ist. */
    var settled = false;
    var fbTimer = setTimeout(function () {
      if (seq !== openSeq || settled) return;
      if (elRecent.hidden) showFallback();
    }, FB_DELAY);

    Promise.all(items.map(function (i) { return fetchProductSlim(i.handle); })).then(function (results) {
      if (seq !== openSeq) return; /* Panel inzwischen geschlossen/neu geöffnet */
      settled = true;
      clearTimeout(fbTimer);
      var invalid = [], products = [];
      for (var k = 0; k < results.length; k++) {
        var r = results[k];
        if (!r || !r.ok) continue;           /* Netz/Timeout: Eintrag behalten */
        if (r.invalid) { invalid.push(items[k].handle); continue; }
        if (r.p && r.p.available !== false) products.push(r.p);
      }
      pruneRecent(invalid);
      if (!products.length) { showFallback(); return; }
      elRecentGrid.innerHTML = products.map(function (p) { return cardHTML(normSlim(p)); }).join('');
      showRecent();
    });
  }

  /* ---------- Letzte Suchen (localStorage, geteilt mit Desktop) ---------- */
  function rsLoad() {
    try {
      var raw = JSON.parse(localStorage.getItem(RS_KEY));
      return Array.isArray(raw) ? raw.filter(function (q) { return typeof q === 'string' && q.trim(); }) : [];
    } catch (e) { return []; }
  }
  function rsPersist(arr) {
    try { localStorage.setItem(RS_KEY, JSON.stringify(arr)); } catch (e) { /* noop */ }
  }
  function rsSave(q) {
    q = String(q || '').trim();
    if (!q || q.length > 60) return;
    var arr = rsLoad().filter(function (item) { return item.toLowerCase() !== q.toLowerCase(); });
    arr.unshift(q);
    rsPersist(arr.slice(0, cfg.searchesLimit));
  }
  function rsRender() {
    if (!cfg.searchesEnabled || !elSearches || !elSearchesList) return;
    var arr = rsLoad().slice(0, cfg.searchesLimit);
    if (!arr.length) { elSearches.hidden = true; elSearchesList.innerHTML = ''; return; }
    var html = '';
    for (var i = 0; i < arr.length; i++) {
      var q = arr[i];
      html += '<span class="snzm-chip">'
        + '<a class="snzm-chip__link" href="' + cfg.localePrefix + '/search?q=' + encodeURIComponent(q) + '&type=product">' + esc(q) + '</a>'
        + '<button type="button" class="snzm-chip__x" data-q="' + esc(q) + '" aria-label="' + esc(cfg.labelRemove) + '">' + ICON_X + '</button>'
        + '</span>';
    }
    elSearchesList.innerHTML = html;
    elSearches.hidden = false;
  }

  /* ---------- Quick Shop (Proxy-Trigger-Pattern, unverändert v5–v8) ----------
     Der native picoapp-Handler bindet nur beim initialen app.mount() – unsere
     Karten entstehen später. Ein bereits gemounteter nativer Trigger
     (außerhalb Drawer, RV-Track und Desktop-Panel) wird mit getauschtem
     data-handle synchron geklickt. Der Drawer bleibt offen (Guard in
     header.liquid über window.__snzQuickShopClick). */
  function triggerQuickShop(handle) {
    var proxy = null;
    var candidates = document.querySelectorAll('[data-mobile-add-to-cart]');
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c.closest('#NavDrawer') && !c.closest('.rv-track') && !c.closest('.snzs-overlay')) { proxy = c; break; }
    }

    if (proxy) {
      var originalHandle = proxy.getAttribute('data-handle');
      proxy.setAttribute('data-handle', handle);
      window.__snzQuickShopClick = true;
      try {
        proxy.click();
      } finally {
        window.__snzQuickShopClick = false;
      }
      if (originalHandle !== null) proxy.setAttribute('data-handle', originalHandle);
      else proxy.removeAttribute('data-handle');
      return;
    }

    /* Fallback: nativen Flow replizieren (ohne app.mount-Garantie) */
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || (cfg.localePrefix + '/');
    fetch(rootPath + 'products/' + handle + '?view=ajax-product')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var modal = document.querySelector('.ModalForm');
        if (!modal) return;
        modal.innerHTML = html;
        modal.classList.add('active');
        var mClose = document.querySelector('[data-close-popup]');
        if (mClose) {
          mClose.addEventListener('click', function () {
            modal.classList.add('close-animation');
            setTimeout(function () {
              modal.classList.remove('close-animation');
              modal.classList.remove('active');
            }, 400);
            setTimeout(function () {
              var popup = document.querySelector('.product-custom-popup');
              if (popup) popup.remove();
            }, 500);
          });
        }
        if (window.app && typeof window.app.mount === 'function') {
          try { window.app.mount(); } catch (err) { /* noop */ }
        }
      })
      .catch(function () { /* noop */ });
  }

  /* ---------- Quick-Shop Drawer-Hold (v6/v7, v10.2 mit Fail-Safe) ---------- */
  var holdObs = null;
  var holdTimer = null;   /* v10.2 (M): Hold endet, wenn das Modal nicht rechtzeitig aktiv wird */

  function qsHoldStop() {
    if (holdObs) { holdObs.disconnect(); holdObs = null; }
    if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
  }

  /* v10.2 (M): Hold und Modal-Beobachtung komplett beenden, wenn der Quick
     Shop nicht zustande kommt – es gibt dann nichts, was wiederhergestellt
     werden müsste. Der Drawer bleibt in dem Zustand, in dem er gerade ist. */
  function qsAbandon() {
    qsHoldStop();
    if (modalObs) { modalObs.disconnect(); modalObs = null; }
    qsRestore = null;
  }

  function qsHoldStart() {
    if (!drawer) return;
    var bodyDrawerClasses = Array.prototype.filter.call(document.body.classList, function (c) {
      return c.indexOf('drawer-open') > -1;
    });
    qsHoldStop();
    holdObs = new MutationObserver(function () {
      if (!drawer.classList.contains('drawer--is-open')) {
        drawer.classList.add('drawer--is-open');
        drawer.classList.add('snzm-active');
        bodyDrawerClasses.forEach(function (c) { document.body.classList.add(c); });
      }
    });
    holdObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    /* v10.2 (M): Fail-Safe – wird das Modal bis dahin nicht aktiv
       (Fetch gescheitert, Slow 3G), hält nichts mehr den Drawer fest */
    holdTimer = setTimeout(qsAbandon, HOLD_TIMEOUT);
  }

  /* ---------- Quick-Shop-Kontext-Restore (v4/v7, unverändert) ---------- */
  var qsRestore = null;
  var modalObs = null;

  function qsSnapshot() {
    qsRestore = {
      q: input ? input.value : '',
      active: !!(drawer && drawer.classList.contains('snzm-active'))
    };
  }

  function qsWatchModal(attempt) {
    var modal = document.querySelector('.ModalForm');
    if (!modal) {
      if ((attempt || 0) < 10) setTimeout(function () { qsWatchModal((attempt || 0) + 1); }, 100);
      else qsAbandon(); /* v10.2 (M): kein Modal im DOM – Hold nicht offen lassen */
      return;
    }
    if (modalObs) { modalObs.disconnect(); modalObs = null; }
    var wasActive = modal.classList.contains('active');
    if (wasActive && holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
    modalObs = new MutationObserver(function () {
      var isActive = modal.classList.contains('active');
      if (isActive && !wasActive) {
        wasActive = true;
        /* v10.2 (M): Modal ist da – ab jetzt gilt der Hold bis zum Schließen des Modals */
        if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
        return;
      }
      if (!isActive && wasActive) {
        wasActive = false;
        modalObs.disconnect();
        modalObs = null;
        setTimeout(function () {
          qsHoldStop();
          qsRestoreState();
        }, 600);
      }
    });
    modalObs.observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  function qsRestoreState() {
    if (!qsRestore) return;
    var st = qsRestore;
    qsRestore = null;
    if (!MOBILE_MQ.matches || !drawer) return;
    if (drawer.classList.contains('drawer--is-open') && drawer.classList.contains('snzm-active')) return;

    if (!drawer.classList.contains('drawer--is-open')) {
      var burger = document.querySelector('.js-drawer-open-nav');
      if (burger) burger.click();
    }
    if (st.active) {
      if (input) input.value = st.q || '';
      if (activeMode) { drawer.classList.add('snzm-active'); refreshContent(st.q || ''); }
      else enterSearchMode();
    }
  }

  /* ---------- Typing: progressiv aus zwei Quellen ---------- */
  function setViewall(q) {
    if (!elViewall) return;
    elViewall.textContent = cfg.viewallLabel.replace('[query]', q);
    elViewall.setAttribute('href', cfg.localePrefix + '/search?q=' + encodeURIComponent(q) + '&type=product');
  }

  function renderSuggestions(q, queries) {
    if (!elSugg || !elSuggList) return;
    var list = (queries || []).filter(function (s) { return s && s.text; }).slice(0, cfg.queryLimit);
    if (!list.length) { elSugg.hidden = true; elSuggList.innerHTML = ''; return; }
    var html = '';
    for (var i = 0; i < list.length; i++) {
      html += '<a class="snzm-sugg__item" data-snzm-sugg href="' + cfg.localePrefix + '/search?q=' + encodeURIComponent(list[i].text) + '&type=product">' + suggMarkup(q, list[i].text) + '</a>';
    }
    elSuggList.innerHTML = html;
    elSugg.hidden = false;
  }

  function runPredictive(q) {
    if (currentController) { try { currentController.abort(); } catch (e) { /* noop */ } }
    currentController = ('AbortController' in window) ? new AbortController() : null;
    var myCtrl = currentController;
    var signal = myCtrl ? myCtrl.signal : undefined;

    setViewall(q);

    var seen = {};
    var count = 0;
    var first = true;   /* erste Antwort ersetzt die Vorgänger-Treffer, zweite hängt an */
    var done = 0;
    var failed = 0;

    function take(list) {
      var html = '';
      for (var i = 0; i < list.length; i++) {
        var o = list[i];
        if (!o.handle || seen[o.handle] || count >= cfg.productLimit) continue;
        seen[o.handle] = 1;
        count++;
        html += cardHTML(o);
      }
      if (first) {
        first = false;
        elProductsGrid.innerHTML = html;
        if (elEmpty) elEmpty.hidden = true;
        if (elError) elError.hidden = true;
      } else if (html) {
        elProductsGrid.insertAdjacentHTML('beforeend', html);
      }
    }

    function finish() {
      done++;
      if (done < 2) return;
      if (failed === 2) {
        elProductsGrid.innerHTML = '';
        if (elEmpty) elEmpty.hidden = true;
        if (elError) elError.hidden = false;
      } else if (count === 0) {
        elProductsGrid.innerHTML = '';
        if (elError) elError.hidden = true;
        if (elEmpty) elEmpty.hidden = false;
      }
    }

    var limitN = Math.min(10, Math.max(cfg.queryLimit, cfg.productLimit, cfg.collectionLimit));

    /* 1) Predictive-Engine: Prefix-Matching, Vorschläge, Kollektionen */
    fetch(
      cfg.localePrefix + '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=query,product,collection'
        + '&resources[limit]=' + limitN
        + '&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=last',
      { signal: signal, credentials: 'same-origin' }
    )
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return undefined; })
      .then(function (data) {
        if (currentController !== myCtrl) return;      /* veraltet (abgebrochen) */
        if (data === undefined) data = null;
        if (data === null) { failed++; finish(); return; }
        var results = (data.resources && data.resources.results) || {};
        renderSuggestions(q, results.queries || []);
        renderCollections(results.collections || []);
        take((results.products || []).map(normSuggest));
        finish();
      });

    /* 2) Volle Suche (search.ajax.liquid v3): Typo-Toleranz/Relaxation */
    fetch(
      cfg.localePrefix + '/search?q=' + encodeURIComponent(q)
        + '&type=product&options[prefix]=last&view=ajax',
      { signal: signal, credentials: 'same-origin' }
    )
      .then(function (res) {
        if (!res.ok) return null;
        return res.text().then(function (text) {
          try { var arr = JSON.parse(text); return Array.isArray(arr) ? arr : []; } catch (e) { return null; }
        });
      })
      .catch(function () { return undefined; })
      .then(function (arr) {
        if (currentController !== myCtrl) return;
        if (arr === undefined) arr = null;
        if (arr === null) { failed++; finish(); return; }
        take(arr.map(normFull));
        finish();
      });
  }

  /* ---------- Tastatur (visualViewport) ---------- */
  var kbBound = false;
  function kbMeasure() {
    if (!drawer) return;
    var vv = window.visualViewport;
    var kb = 0;
    if (vv && drawer.classList.contains('drawer--is-open') && drawer.classList.contains('snzm-active')) {
      kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    }
    drawer.style.setProperty('--snzm-kb', kb + 'px');
  }
  function kbWatch(on) {
    var vv = window.visualViewport;
    if (!vv) return;
    if (on && !kbBound) {
      kbBound = true;
      vv.addEventListener('resize', kbMeasure);
      vv.addEventListener('scroll', kbMeasure);
    } else if (!on && kbBound) {
      kbBound = false;
      vv.removeEventListener('resize', kbMeasure);
      vv.removeEventListener('scroll', kbMeasure);
    }
    kbMeasure();
  }

  /* ---------- State ---------- */
  function setState(state) {
    if (!elIdle || !elTyping) return;
    if (state === 'typing') { elIdle.hidden = true; elTyping.hidden = false; }
    else {
      elTyping.hidden = true;
      elIdle.hidden = false;
      if (currentController) { try { currentController.abort(); } catch (e) { /* noop */ } currentController = null; }
      loadRecent();
      rsRender();
    }
  }
  function refreshContent(q) {
    if (q == null) q = input ? input.value : '';
    q = q.trim();
    clearTimeout(debounceTimer);
    if (q === '') { setState('idle'); return; }
    setState('typing');
    debounceTimer = setTimeout(function () { runPredictive(q); }, DEBOUNCE);
  }

  /* v10.1: idempotent – wird von focusin, vom Klassen-Observer und von open()
     erreicht; Inhalt wird nur beim ersten Einstieg geladen */
  function enterSearchMode() {
    if (!MOBILE_MQ.matches || !drawer) return;
    if (!drawer.classList.contains('snzm-active')) drawer.classList.add('snzm-active');
    if (activeMode) { kbMeasure(); return; }
    activeMode = true;
    kbWatch(true);
    refreshContent();
  }
  function exitSearchMode(clearInput) {
    if (!drawer) return;
    activeMode = false;
    openSeq++; /* laufende Recent-Antworten verwerfen */
    clearTimeout(debounceTimer);
    if (currentController) { try { currentController.abort(); } catch (e) { /* noop */ } currentController = null; }
    drawer.classList.remove('snzm-active');
    kbWatch(false);
    if (clearInput && input) input.value = '';
    if (elIdle && elTyping) { elTyping.hidden = true; elIdle.hidden = false; }
  }

  /* v10.1 FIX 1: Klassen-Observer – snzm-active von außen gesetzt (MTB o. ä.)
     startet den Suchmodus; von außen entfernt (z. B. Drawer-Close) räumt auf.
     v10.2 (K): verschwindet drawer--is-open (closeDrawer in header.liquid:
     Tap außerhalb, ESC), endet der Suchmodus ebenfalls – mit geleertem Feld,
     wie beim Close-Button. Sonst zeigte der nächste Burger-Tap die Suche. */
  function watchDrawerClass() {
    if (!window.MutationObserver || !drawer) return;
    if (classObs) { classObs.disconnect(); classObs = null; }
    classObs = new MutationObserver(function () {
      if (holdObs) return; /* Quick-Shop-Hold toggelt die Klassen im selben Frame – nicht reagieren */
      var isOpen = drawer.classList.contains('drawer--is-open');
      var on = drawer.classList.contains('snzm-active');
      if (!isOpen && (on || activeMode)) { exitSearchMode(true); return; }
      if (on && !activeMode) enterSearchMode();
      else if (!on && activeMode) exitSearchMode(false);
    });
    classObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* v10.1 FIX 2: öffentliche API für Trigger außerhalb des Drawers (MTB).
     Synchron innerhalb der Nutzergeste aufrufen, sonst öffnet iOS die
     Tastatur nicht. Klassen-Mechanik identisch zu header.liquid openDrawer(). */
  function openFromOutside() {
    if (!drawer) init();
    if (!drawer || !input) return false;
    if (!MOBILE_MQ.matches) return false;
    if (!drawer.classList.contains('drawer--is-open')) {
      drawer.classList.remove('drawer--loading');
      drawer.classList.add('drawer--is-open');
      document.documentElement.classList.add('js-drawer-open');
      document.body.classList.add('js-drawer-open');
      if (window.theme && window.theme.NavDrawer) window.theme.NavDrawer.isOpen = true;
    }
    if ('inert' in drawer) drawer.inert = false; /* der Drawer-Observer flippt erst asynchron */
    enterSearchMode();
    try { input.focus({ preventScroll: true }); } catch (e) { try { input.focus(); } catch (e2) { /* noop */ } }
    return true;
  }

  /* ---------- DOM ---------- */
  function cacheEls() {
    elIdle         = root.querySelector('[data-snzm-state="idle"]');
    elTyping       = root.querySelector('[data-snzm-state="typing"]');
    elRecent       = root.querySelector('[data-snzm-recent]');
    elRecentGrid   = root.querySelector('[data-snzm-recent-grid]');
    elFallback     = root.querySelector('[data-snzm-fallback]');
    elFallbackGrid = root.querySelector('[data-snzm-fallback-grid]');
    elSpot         = root.querySelector('[data-snzm-spot-tile]');
    elProductsGrid = root.querySelector('[data-snzm-products-grid]');
    elEmpty        = root.querySelector('[data-snzm-empty]');
    elError        = root.querySelector('[data-snzm-error]');
    elViewall      = root.querySelector('[data-snzm-viewall]');
    elSearches     = root.querySelector('[data-snzm-searches]');
    elSearchesList = root.querySelector('[data-snzm-searches-list]');
    elSugg         = root.querySelector('[data-snzm-suggestions]');
    elSuggList     = root.querySelector('[data-snzm-suggestions-list]');
    elColls        = root.querySelector('[data-snzm-collections]');
    elCollsList    = root.querySelector('[data-snzm-collections-list]');
  }

  function num(attr, def, max) {
    var n = parseInt(root.getAttribute(attr), 10);
    if (isNaN(n) || n < 1) n = def;
    if (max && n > max) n = max;
    return n;
  }

  function readCfg() {
    cfg.localeRoot      = root.getAttribute('data-locale-root') || '/';
    cfg.localePrefix    = (cfg.localeRoot === '/' ? '' : cfg.localeRoot.replace(/\/$/, ''));
    cfg.recentLimit     = num('data-recent-limit', 6, 12);
    cfg.productLimit    = num('data-product-limit', 6, 12);
    cfg.queryLimit      = num('data-query-limit', 3, 5);
    cfg.collectionLimit = num('data-collection-limit', 4, 4);
    cfg.newTag          = (root.getAttribute('data-new-tag') || '').toLowerCase();
    cfg.badgeLabel      = root.getAttribute('data-badge-label') || '';
    cfg.showBadge       = root.getAttribute('data-show-badge') === 'true';
    cfg.showHeart       = root.getAttribute('data-show-heart') === 'true';
    cfg.viewallLabel    = root.getAttribute('data-viewall-label') || 'Alle Ergebnisse ansehen';
    cfg.moneyFormat     = root.getAttribute('data-money-format') || '{{amount}}';
    cfg.saleLabel       = root.getAttribute('data-sale-label') || 'Sale';
    cfg.searchesLimit   = num('data-searches-limit', 4, 6);
    cfg.searchesEnabled = root.getAttribute('data-searches-enabled') !== 'false';
    cfg.labelAtc        = root.getAttribute('data-label-atc') || 'Add to cart';
    cfg.labelRemove     = root.getAttribute('data-label-remove-search') || 'Remove';
    cfg.labelWishlist   = root.getAttribute('data-label-wishlist') || 'Wishlist';
    cfg.currentHandle   = document.documentElement.dataset.productHandle || null;
  }

  function isSearchInput(target) {
    return target && target.classList && target.classList.contains('site-header__search-input');
  }
  function inDrawerSearch(target) {
    return target && target.closest && target.closest('#NavDrawer') && isSearchInput(target);
  }

  /* ---------- Event-Handler (Capture-Phase) ---------- */
  function onFocusIn(e) {
    if (!MOBILE_MQ.matches) return;
    if (inDrawerSearch(e.target)) enterSearchMode();
  }
  function onInput(e) {
    if (!MOBILE_MQ.matches) return;
    if (!inDrawerSearch(e.target)) return;
    if (!activeMode) { enterSearchMode(); return; } /* lädt bereits mit dem aktuellen Feldwert */
    refreshContent(e.target.value);
  }
  function onKeyup(e) {
    if (!MOBILE_MQ.matches) return;
    if (!inDrawerSearch(e.target)) return;
    if (e.keyCode === 27) { qsAbandon(); exitSearchMode(true); return; } /* ESC nur im Drawer-Suchfeld; v10.2 (M): Kunde hat Vorrang vor dem Hold */
    if (!activeMode) { enterSearchMode(); return; }
    refreshContent(e.target.value);
  }
  function onSubmit(e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (!f.matches('#DrawerSearchForm')) return;
    var inp = f.querySelector('input[name="q"]');
    if (inp && inp.value.trim()) rsSave(inp.value.trim());
  }
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* Chip-X: einzelne letzte Suche löschen */
    var x = t.closest('.snzm-chip__x');
    if (x && root && root.contains(x)) {
      e.preventDefault();
      e.stopPropagation();
      var q = x.getAttribute('data-q');
      rsPersist(rsLoad().filter(function (item) { return item !== q; }));
      rsRender();
      return;
    }

    /* Quick Shop (ATC) im Panel – nativer Karten-Klon */
    var atc = t.closest('[data-mobile-add-to-cart]');
    if (atc && root && root.contains(atc)) {
      e.preventDefault();
      e.stopPropagation();
      var handle = atc.getAttribute('data-handle');
      if (handle) {
        qsSnapshot();
        qsWatchModal(0);
        qsHoldStart();
        triggerQuickShop(handle);
      }
      return;
    }

    /* Vorschlag / View-all: Begriff in letzte Suchen aufnehmen, Navigation läuft weiter */
    var sv = t.closest('[data-snzm-sugg], [data-snzm-viewall]');
    if (sv && root && root.contains(sv)) {
      try {
        var url = new URL(sv.href, window.location.origin);
        var vq = url.searchParams.get('q');
        if (vq) rsSave(vq);
      } catch (err) { /* noop */ }
    }

    /* v10.2 (M): ausdrückliches Schließen durch den Kunden hat Vorrang vor
       dem Quick-Shop-Hold – sonst dreht der Hold den Klick sofort zurück */
    if (t.closest('.js-snzm-cancel')) {
      e.preventDefault();
      qsAbandon();
      exitSearchMode(true);
      if (input) input.blur();
      return;
    }
    if (t.closest('#NavDrawer .js-drawer-close')) { qsAbandon(); exitSearchMode(true); return; }
    if (t.closest('#NavDrawer .js-search-header-close')) {
      if (MOBILE_MQ.matches && drawer && drawer.classList.contains('snzm-active')) {
        e.preventDefault();
        e.stopPropagation();
        if (input) input.value = '';
        setState('idle');
        if (input) input.focus();
      }
    }
  }

  function bindDocumentOnce() {
    if (docBound) return;
    docBound = true;
    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('input', onInput, true);
    document.addEventListener('keyup', onKeyup, true);
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('shopify:section:load', function () { init(); });
  }

  function init() {
    drawer = document.getElementById('NavDrawer');
    if (!drawer) return;
    root = drawer.querySelector('[data-snzm-search]'); /* #12: im Drawer, nie dokumentweit */
    if (!root) return;

    cacheEls();
    readCfg();
    input = drawer.querySelector('#DrawerSearchForm .site-header__search-input')
         || drawer.querySelector('.site-header__search-input');

    activeMode = false;
    watchDrawerClass();
    /* Klasse stand schon vor dem Init (Trigger war schneller als das Asset) */
    if (drawer.classList.contains('snzm-active')) enterSearchMode();

    bindDocumentOnce();
  }

  window.SnzmSearchMobile = { reinit: init, open: openFromOutside };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();